import { createSlice } from "@reduxjs/toolkit";

export const activitySlice = createSlice({
  name: "activity",
  initialState: {
    activity: [],
    loadingHistory: true,
  },
  reducers: {
    updateActivity: (state, action) => {
      state.activity = action.payload;
      //   state.value = [action.payload]
    },
    updateActivityLoading: (state, action) => {
      state.loadingHistory = action.payload;
    },
  },
});
// Action creators are generated for each case reducer function
export const { updateActivity, updateActivityLoading } = activitySlice.actions;

export default activitySlice.reducer;
